/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12,22.5c4.6,0,8.3-3.4,8.9-7.8c0.1-0.6-0.5-1.2-1.1-1.1C15.4,14.2,12,17.9,12,22.5z M5.6,10.8 c0,1.4,1.1,2.5,2.5,2.5c0.5,0,1-0.2,1.4-0.4v0.2c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-0.2c0.4,0.3,0.9,0.4,1.4,0.4 c1.4,0,2.5-1.1,2.5-2.5c0-1-0.6-1.9-1.4-2.2c0.8-0.4,1.4-1.2,1.4-2.2c0-1.4-1.1-2.5-2.5-2.5c-0.5,0-1,0.2-1.4,0.4V4.1 c0-1.4-1.1-2.5-2.5-2.5S9.5,2.6,9.5,4v0.2C9.1,3.9,8.6,3.8,8.1,3.8c-1.4,0-2.5,1.1-2.5,2.5c0,1,0.6,1.9,1.4,2.2 C6.2,8.9,5.6,9.8,5.6,10.8z M12,6c1.4,0,2.5,1.1,2.5,2.5S13.4,11,12,11S9.5,9.9,9.5,8.5S10.6,6,12,6z M3.1,14.7 c0.6,4.4,4.4,7.8,8.9,7.8c0-4.6-3.4-8.3-7.8-8.9C3.6,13.5,3,14.1,3.1,14.7z"
}), 'CategoryFJ', {
  viewBox: '0 0 24 24'
});